
export const SessionVariables = {

  token: 'AWAG.DealerPortal.Token'

}
